const encodeHeroImageUrl = (url) => url.replace(/\+/g, "%20").replace(/\(/g, "%28").replace(/\)/g, "%29")

export const isHomeFullImageHero = (pages) => {
  if (!pages || !Array.isArray(pages)) return false
  const homePage = pages.find((p) => p.defaultPageType === "home")
  const homeHero = homePage?.sections?.find((s) => s.layout === "hero")
  const heroLayout = homeHero?.settings?.layout || homeHero?.layout_variant || null
  return heroLayout === "full_image"
}

export const getReviewHeroLayout = (section) => section?.settings?.layout || "full_image"

export const isFullImageHeroLayout = (layout) =>
  layout === "full_image" || (typeof layout === "string" && layout.startsWith("full_image"))

export const getReviewHeroImageUrl = (section) => {
  const settings = section?.settings || {}
  const customImageUrl = section?.imageUrl?.trim() || settings.images?.[0]?.url?.trim()
  return customImageUrl ? encodeHeroImageUrl(customImageUrl) : null
}

/**
 * Resolve the reviews hero background image.
 * Custom section image takes priority over the home page full-image hero fallback.
 * Layout must be a full-image variant for a background image to display.
 */
export const getReviewHeroImage = ({ section, practice, pages }) => {
  const settings = section?.settings || {}
  const layout = getReviewHeroLayout(section)
  const customImageUrl = getReviewHeroImageUrl(section)

  if (customImageUrl && isFullImageHeroLayout(layout)) {
    return {
      heroImageUrl: customImageUrl,
      useHeroImage: true,
      source: "custom"
    }
  }

  const homeHasFullImage = isHomeFullImageHero(pages)
  const useHomeHeroImage = settings.useHomeHeroImage !== false && homeHasFullImage && practice?.headerHeroImageUrl
  // Solid color mode (light/dark) takes precedence over inheriting the home page hero image.
  const preferSolidColorBackground =
    settings.colorMode === "light" ||
    settings.colorMode === "dark" ||
    settings.backgroundColor === "theme" ||
    settings.backgroundColor === "dark"

  if (isFullImageHeroLayout(layout) && useHomeHeroImage && !preferSolidColorBackground) {
    return {
      heroImageUrl: encodeHeroImageUrl(practice.headerHeroImageUrl),
      useHeroImage: true,
      source: "home"
    }
  }

  return {
    heroImageUrl: null,
    useHeroImage: false,
    source: null
  }
}

export const shouldShowReviewHeroRatingSummary = (settings = {}) => {
  if (settings.showRatingSummary === false) return false
  if (settings.showReviews === false) return false
  return true
}

export const getReviewHeroOverlayOpacity = (settings = {}) => {
  const opacity = Number(settings.overlayOpacity)
  return Number.isFinite(opacity) ? Math.min(100, Math.max(0, opacity)) : 30
}

export const getReviewHeroBackgroundColor = ({ section, theme, useHeroImage }) => {
  if (useHeroImage) return "transparent"

  const settings = section?.settings || {}
  if (settings.useThemeBackground === false) {
    return settings.backgroundColor || "#FFFFFF"
  }

  return theme?.colors?.bgLight || theme?.colors?.background || "#FFFFFF"
}
